import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["showHeroCard", "className", "getItButtonOverride", "insightIntent", "hideAiInsights", "emptyState"];
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { Recommendations, RecommendationsError } from '../../Components/Recommendations';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useResultsPageContext } from './ResultsPageContext';
export const ResultsRecommendations = _ref => {
  let _ref$showHeroCard = _ref.showHeroCard,
    showHeroCard = _ref$showHeroCard === void 0 ? true : _ref$showHeroCard,
    className = _ref.className,
    getItButtonOverride = _ref.getItButtonOverride,
    insightIntent = _ref.insightIntent,
    _ref$hideAiInsights = _ref.hideAiInsights,
    hideAiInsights = _ref$hideAiInsights === void 0 ? false : _ref$hideAiInsights,
    emptyState = _ref.emptyState,
    recommendationsProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _useResultsPageContex = useResultsPageContext(),
    recommendations = _useResultsPageContex.recommendations,
    isLoading = _useResultsPageContex.isLoading,
    isLeadingCardLoading = _useResultsPageContex.isLeadingCardLoading,
    hasMore = _useResultsPageContex.hasMore,
    error = _useResultsPageContex.error,
    onRetry = _useResultsPageContex.onRetry,
    fetchNextPage = _useResultsPageContex.fetchNextPage,
    isFetchingNextPage = _useResultsPageContex.isFetchingNextPage,
    resolveActionForSuggestion = _useResultsPageContex.resolveActionForSuggestion,
    useCompactRecommendationsLayout = _useResultsPageContex.useCompactRecommendationsLayout,
    deviceType = _useResultsPageContex.deviceType,
    productType = _useResultsPageContex.productType,
    isPricingLoading = _useResultsPageContex.isPricingLoading;
  if (error) {
    if (error === 'NoRecommendations' && emptyState !== undefined) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, emptyState);
    }
    return /*#__PURE__*/React.createElement(RecommendationsError, {
      error: error,
      onRetry: onRetry,
      type: "anonymous",
      gridColumn: "1 / -1"
    });
  }
  return /*#__PURE__*/React.createElement(Recommendations, _extends({
    recommendations: recommendations,
    isLoading: isLoading,
    isLeadingCardLoading: isLeadingCardLoading,
    hasMore: hasMore,
    className: className,
    showHeroCard: showHeroCard,
    useCompactRecommendationsLayout: useCompactRecommendationsLayout,
    getItButtonOverride: getItButtonOverride,
    isPricingLoading: isPricingLoading
  }, recommendationsProps, {
    onAiInsightsClick: hideAiInsights ? undefined : domain => {
      var _recommendations$posi;
      const position = recommendations.findIndex(r => r.domain === domain);
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'ai_insights_button',
        domain,
        position,
        type: (_recommendations$posi = recommendations[position]) == null ? void 0 : _recommendations$posi.label,
        deviceType: deviceType === 'Smartphone' ? 'mobile' : 'desktop'
      });
      DomainSearchGateModule.internals.insightsModalsController.aiInsights.show({
        domain,
        ...(insightIntent && {
          intent: {
            intent: insightIntent
          }
        }),
        ...(productType && {
          productType
        }),
        onGetIt: clickedDomain => {
          const index = recommendations.findIndex(r => r.domain === clickedDomain);
          if (index === -1) {
            return;
          }
          const type = recommendations[index].label;
          DomainSearchSuiteModule.internals.bi.onGetItClick == null || DomainSearchSuiteModule.internals.bi.onGetItClick({
            origin: 'ai_insights_modal',
            domain: clickedDomain,
            type,
            position: index
          });
          resolveActionForSuggestion(clickedDomain);
        }
      });
    },
    fetchNextPage: () => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'show_more_results'
      });
      fetchNextPage();
    },
    isFetchingNextPage: isFetchingNextPage,
    gridArea: "content"
  }));
};
//# sourceMappingURL=ResultsRecommendations.js.map